import {DEFAULT_ERROR} from '../error_handler/error_handler';

export class ERRORS {
    static get GENERAL_ERROR() {
        return DEFAULT_ERROR;
    }

    static get INVALID_REPLY_ESB() {
        return DEFAULT_ERROR;

    }

    static get WATCHLIST_DOES_NOT_EXIST() {
        return DEFAULT_ERROR;
    }
}



// WEBPACK FOOTER //
// ./src/modules/media_list/medialist_errors.js